//-------------------------------------------------------------------------//
// System Enums
//-------------------------------------------------------------------------//
"use strict";
// Webshop specific ENUMS
export const ProfileNavSectionsEnum = { Profile: 'profile', Orders: 'orders', Wishlist: 'wishlist', Carts: 'carts', Referral: 'referral', Loyalty: 'loyalty', Dashboard:'dashboard'};
export const SitePageContentTypeEnum = { Html: 1, Url: 2 };
export const PageNavSectionsEnum = { Shipping: 'Shipping', Refunds: 'Refunds', Delivery: 'Delivery', FAQs: 'FAQs', Privacy: 'Privacy' };
export const Drop = { NoDrop: 'NoDrop', DropEmpty: 'DropEmpty', DropHalfFull: 'DropHalfFull', DropFull: 'DropFull' };
export const CheckoutWizardSteps = { ShippingAddress: 1, Payment: 2, Review: 3 };
export const OpenpayCheckoutStatusEnum = { Lodged: 'LODGED', Cancelled: 'CANCELLED', Failure: 'FAILURE', Errored: 'Errored', Refused: 'Refused' };
export const CookieTypeEnum = { Analytics: 'analytics', Essential: 'essential', Marketing: 'marketing' };

const ContactReasonNorway = [ 'RequestLoginDetails', 'BookADemo' ];
const ContactReasonFinland =  [ 'RequestLoginDetails', 'BookADemo' ];
const ContactReasonSweeden = [ 'RequestLoginDetails', 'BookADemo' ];
const ContactReasonATWest = [ 'BookADemo' ];
const ContactReasonCanada = [ 'SignUpForNews' ,  'BookPersonalAppointment',  'BookGroupDemo',  'QuestionAboutProducts',  'BecomingAnENJOpreneur' ];
const ContactReasonUKX = [  'SignUpForNews' ,  'BookPersonalAppointment',  'BookGroupDemo', 'QuestionAboutProducts', 'BecomingAnENJOpreneur' ];

export const SuppliersContactReasonEnum = { 1 : ContactReasonUKX, 14 : ContactReasonSweeden, 15 : ContactReasonFinland, 19: ContactReasonATWest, 20 : ContactReasonCanada, 36 : ContactReasonNorway }


//-------------------Merlin Enums------------------------------------
export const PaymentStatusEnum = {
    Pending: 0, Successful: 1, Failed: 2, None: 3, NoPaymentRequired: 4,
    PaymentOnOrder: 5,
    PaymentOnOrderApproval: 6,
    RequiresActionExternalRedirect: 7,
    RequiresPaymentMethod : 8,
    RequiresActionKlarna : 9,
    RequiresCapture : 10,
};
export const LanguageEnum = { english: 1 };
export const DiscountModelUsedEnum = { PNT: 0, GRV: 1, Points: 2 };
export const DiaryEventStatusEnum = { InProgress: 1, Completed: 2, Canceled: 3 };
export const DiaryEventTypeEnum = { Task: 1, Demo: 2, Order: 3, Sale: 4, Reminder: 5, ServiceCall: 6, Event: 7, AfterSaleCall: 8, Birthday: 9, HostCoach: 10, AutomaticCustomerSupport: 11 };

export const OrderedByTypeEnum = { None: 0, Consultant: 1, Customer: 2, HeadOffice: 3 };
export const LeadershipModelEnum = { Leadership: 0, Recruiting: 1 };

export const CustomerTypeEnum = { All: 0, Hosts: 1, DemoGuests: 2, Individual: 3, Webshop: 4, ENJOpreneurs: 5, Makeover: 6 };
export const CustomerPickerTypesEnum = { MyCustomers: 1, AllCustomers: 2, PoolCustomers: 3 };
export const CustomerPotentialsFilterEnum = { IsPotentialConsultant: 1, IsPotentialHost: 2, IsPotentialNBO: 3, IsHost: 4, IsDiamondClub: 5, IsMarketingMagazineRequired: 6 };

export const UIViewTypeEnum = { User: 1, Team: 2, Warehouse: 3, Admin: 4, Report: 5, HelpDesk: 6, Master: 7, HeadOffice: 8 };
export const UIDeviceTypeEnum = { Normal: 1, Mobile: 2, Tablet: 3 };
export const GridViewUITypeEnum = { Grid: 1, Map: 2, Dashboard: 3 };

export const ZoneChangeReasonEnum = { New: 1, Renewed: 2, Expired: 3, NoChange: 4, Incomplete: 5 };
export const EnjoPureStatusEnum = { Active: 1, Expired: 2 };

export const CustomerZoneViewsEnum = { Zones: 0, ZoneChanges: 1, ZoneModels: 2, ZoneModelChanges: 3 };
export const ConsultantDetailsViewEnum = { Details: 0, Customers: 1, Demos: 2, Sales: 3, Orders: 4, Team: 5, EarningReport: 6, Corrections: 7, Zones: 8, AnnualSummary: 12 };
export const UserRolesEnum = { Master: 1, Admin: 2, Consultant: 3, HeadOffice: 4, SuperAdmin: 5, Warehouse: 6, BusinessLeader: 7, Customer: 8, InactiveConsultant: 9 };
export const RolesEnum = { None: { Id: 0, Rank: 0 }, Customer: { Id: 8, Rank: 10 }, InactiveConsultant: { Id: 9, Rank: 20 }, Consultant: { Id: 3, Rank: 30 }, BusinessLeader: { Id: 7, Rank: 40 }, Warehouse: { Id: 6, Rank: 50 }, HeadOffice: { Id: 4, Rank: 60 }, Admin: { Id: 2, Rank: 70 }, SuperAdmin: { Id: 5, Rank: 80 }, Master: { Id: 1, Rank: 90 } };
export const ExceptionTypes = { None: -1, PaymentError: 0, SaleSubmitError: 1, UpdateConsultantError: 2, HistoryRecordingError: 3, RefundSaleSubmitError: 4, WebshopSaleSubmitError: 5, DemoSaleExistsError: 6 };

export const NoOfCompletedZonesColorEnum = { Zone0: "D66C6D", Zone1: "FDDD33", Zone2: "D79BBD", Zone3: "A75A85", Zone4: "0A6BE1", Zone5: "bef497", Zone6: "84ed90", Zone7: "317700" };

export const UIOrderViewEnum = { Basic: 0, Advanced: 1 };
export const UIHomeTabsViewEnum = { WeeklyTasks: 1, Dashboard: 2, Enjopure: 3, Achievements: 4, Customers: 5 };
//---------------------------------------------

export const DeliveryOptionType = { None: 0, DeliverToEPR: 1, DirectDelivery: 2, CustomerGroup: 3, CollectingFromWarehouse: 4 };
export const DiscountSource = { ConsultantFixed: 0, ProgramFixed: 1, Program: 2, Band: 3, Junior: 4, OnHoldOrBusinessLeader: 5 };

export const BandModelEnum = { PNT: 0, GRV: 1, CountedPoints: 2 };
export const BandPaymentModelEnum = { PNT: 0, NetSales: 1 };
export const LeadershipLevelActiveModelEnum = { None: 0, GreenMonth: 1, PNT: 2, Points: 3, GRV: 4 };
//-------------------------------------------------------------------
export const SummaryReportVisibility = { Detailed: 1, Summary: 2, AWCustom: 3 };
//-------------------------------------------------------
export const TelebankingFileType = { Debit: 1, Credit: 2 };
//-------------------------------------------------------
export const BoxUnitEnum = { CM: 0, Inch: 1, Millimetre: 2, Metre: 3, Foot: 4, Yard: 5 };
/*
 * these enums will be auto generated from Server Side Enums using this url "/Home/GetEnums"
 * to remove headache of maintaining server and client enums to be identical
 * so if you changed one of these server side enums please open the url "/Home/GetEnums" in browser and copy the modified en
 * I can add it as script url in layout page but we will lose the intellisense , so later we can think about solution to it
*/
export const SystemEntitiesEnum = {
    "Product": 1, "StockItem": 2,
    "ProductGroup": 3, "ProductAttributeType": 4, "ProductAttribute": 5,
    "ProductFilter": 6, "ProductsFilters": 7, "PriceCode": 8, "Price": 9,
    "Zone": 10, "ZoneModel": 11, "LookupConfig": 12, "DemoType": 13, "Region": 14,
    "DeliveryService": 15, "StockBOMItem": 16, "StockItemVariation": 17,
    "StockItemTransaction": 18, "Reminder": 19, "ProductDefaultSetting": 20,
    "StockItemLowStock": 21, "Sale": 22, "SaleDetail": 23, "Order": 24, "OrderDetail": 25,
    "AchievementSetting": 26, "Achievement": 27, "ProductTranslation": 28, "Supplier": 29,
    "StockTaking": 30, "Consultant": 31, "LeaderStats": 32, "AchievementSettingCondition": 33,
    "PromotionProductGroup": 34, "PromotionProductTag": 35, "PromotionStockItem": 36, "PromotionItem": 37,
    "Program": 38, "ProgramAction": 39, "ProgramConsultant": 40, "ProgramConsultantAction": 41, "ConsignmentDetail": 42,
    "Demo": 43, "PaymentGatewayLog": 44, "ProgramReward": 45, "NotificationTemplate": 46
};
export const SuppliersEnum = {
    "UKX": 1, "VBG": 3, "BG": 6, "SI": 8, "INT": 12, "INT-DE": 13, "SE": 14, "FI": 15,
    "DE": 16, "FR": 17, "AT-EAST": 18, "AT-WEST": 19, "CA": 20, "NZ": 22, "USGA": 23, "USNW": 24,
    "BE": 25, "BR": 26, "CZ": 27, "DK": 28, "NL": 29, "FO": 30, "IS": 31, "IE": 32, "IT": 33,
    "JP": 34, "LU": 35, "NO": 36, "PT": 37, "SG": 38, "ZA": 39, "CH": 40, "AE": 41, "PH": 42,
    "IT-ST": 43, "ES": 44, "YACHT": 45, "SUP1": 47, "US": 48, "DEM": 49
};
export const EISuppliersEnum = { "VBG": 3, "SE": 14, "FI": 15, "DE": 16, "DK": 28, "IT": 33, "CH": 40 };
export const StockItemTransactionTypesEnum = { "StockInGoodsIn": 1, "StockInReturned": 2, "StockInAdjustments": 3, "StockOutOrder": 4, "StockOutAdjustments": 5, "StockOutAllocated": 6 };
export const PromotionTypesEnum = { "Promotion": 1, "Marketing": 2 };
export const PromotionItemDiscountTypeEnum = { "FixedPrice": 1, "FixedValue": 2, "Percentage": 3, "HostGiftExtraBonus": 4 };
export const PromotionItemTypeEnum = { "StockItem": 1, "Product": 2, "ProductGroup": 3, "ProductTag": 4 };
export const ProductDropEnum = { "DropFull": 1, "DropHalfFull": 2, "DropEmpty": 3, "NoDrop": 4 };
export const LookupStatusEnum = { "Active": 1, "Inactive": 2, "Archived": 3 };
export const FilterOperatorEnum = { "Unknown": 0, "Like": 1, "Contain": 2, "Equal": 3, "GreaterThan": 4, "LessThan": 5, "GreaterThanOrEqual": 6, "LessThanOrEqual": 7, "In": 8, "StartWith": 9 };
export const FilterCategoriesEnum = { "None": 0, "Item": 1, "Area": 2, "Material": 3, "Pollution": 4 };
export const ZoneModelTypesEnum = { "Makeover": 0, "ThreeZoner": 1 };
export const ProductBoolFieldsFilterEnum = { "IsCommissionable": 1, "IsBOM": 2, "IsBigQuantities": 3, "IsPhysicalStock": 4, "IsWebshop": 5, "IsBusiness": 6, "IsCustomerSale": 7, "IsOwnUse": 8, "IsSet": 9, "IsFeatured": 10, "ShowInSlider": 11, "ShowOnSetGroup": 12, "AllowAsHostGift": 13, "PreventGeneralSelectionAsHostGift": 14, "IsNotBOM": 15 };

export const PackagingStatusEnum = { "NotPackaged": 0, "PartiallyPackaged": 1, "Packaged": 2, "LabelCreated": 3 }

export const TimeLengthTypesEnum = { Day: 1, Week: 2, Month: 3, Year: 4 };
export const ProgramStatusesEnum = { NotStarted: 0, Started: 1, Completed: 2, Processed: 3 };

export const DiscountValueCalculationModelEnum = { None: 0, IncludeTax: 1, ExcludeTax: 2 };

export const CustomerStatusEnum = { Inactive: 0, Active: 1/*, Quit: 2*/ };
/*export const ConsultantStatusEnum = { Inactive: 0, Active: 1*//*, Quit: 2*//* };*/
export const RetailTypesEnum = { Retail: 1, Wholesale: 2 };
export const GenderEnum = { Female: 1, Male: 2 };
export const CustomerTitleEnum = { Select: -1, Mr: 1, Mrs: 2, Company: 3, Miss: 4, Lady: 5, Ms: 6, Dr: 7, DDr: 8, BEng: 9, MSE: 10, MSC: 11 };
export const EprTitleEnum = {
    Select: -1, Mr: 1, Mrs: 2, Company: 3, Miss: 4, Lady: 5, Ms: 6, Dr: 7, DDr: 8, BEng: 9, MSE: 10, MSC: 11
};
export const LookConfigTypesEnum = { Age: 1, Dwelling: 2, ClothesSize: 3 };

export const AchievementConditionTypesEnum = { Points: 1, QualifiedRecruits: 2, CommissionableSales: 3, ConsecutiveGreenMonth: 4 };
export const AchievementBonusValueTypesEnum = { FixedValue: 0, PercentageOfCommissionablePrice: 1 };
export const AchievementTypesEnum = { Consultant: 1, Customer: 2 };
export const CustomerAchievementTypesEnum = { Select: 0, PremiumCustomer: 1 };
export const ProductTypeEnum = { Product: 1, Service: 2, Bundle: 3 };
export const LedgerRecordTypeEnum = { Order: 0, Sale: 1, Demo: 2, Correction: 3, RefundCounterOrder: 4, RefundCounterSale: 5, OrderCorrection: 6, CommissionDifference: 7 };
export const PaymentMethodEnum = {
    None: 0, Card: 1, Cheque: 2, Cash: 3, Gift: 4,
    BankTransfer: 5, Swish: 6, SumUp: 7, EWallet: 8, Webshop: 9, Correction: 10,
    PaymentTakenOnOrder: 11,
    CollectorBank: 12,
    DirectDebit: 13,
    NZExternalCardPayment: 14,
    OpenPay: 15,
    Instalment: 16,
    CollectorBankOrderApproval: 17,
    Klarna: 18,
    MobilePay: 19,
    StripeLink: 20,
};

export const SaleTypesEnum = { Any: 0, OneToOne: 1, Demo: 2, BusinessSale: 3, OwnUse: 4, Webshop: 5, Corrections: 6, OwnStock: 7, HeadOfficeSale: 8, Subscription : 9 };
export const SaleStatusEnum = { New: 1, Ordered: 2, Cancelled: 3 };
export const DemoStatusEnum = { Open: 1, Closed: 2, Canceled: 4, PartialyOrdered: 5, Ordered: 6, Postponed: 7 };
export const OrderStatusEnum = { New: 1, Provisional: 2, Cancelled: 3, Ordered: 4, Warehouse: 5, Dispatched: 6, Refunded: 7, RefundCounterOrder: 8, PartiallyRefunded: 9, PartialRefundCorrection: 10, CorrectionCredit: 11, CorrectionCharge: 12 };
export const OrderRefundStatusEnum = { None: 0, Refunded: 1, RefundCounter: 2, PartiallyRefunded: 3, PartialRefundCorrection: 4 };

export const StockItemTypesEnum = { Default: 0, OneToOne: 1, Demo: 2, Business: 3, Ownuse: 4, WebShop: 5, Corrections: 6, OwnStock: 7 };
export const ItemCommissionableStatusesEnum = { None: 0, Commissionable: 1, NonCommissionable: 2 };
export const CustomerDiscountTypesEnum = { None: 0, PriceCode: 1, HostGift: 2, Promotion: 3, Ownuse: 5 /*Business : 4,WebShop : 6*/ };

export const ReportGroupLevelsEnum = { None: 0, Year: 1, Month: 2, Week: 3 };
export const AddressPartEnum = { Address1: 1, Address2: 2, Address3: 3, Address4: 4, PostCode: 5, Region: 6, Country: 7, Organization: 8 };

export const SitePageContentTypesEnum = { Html: 1, Url: 2 };
export const SitePagePositionsEnum = { TopBarMenu: 1, SideMenu: 2, FooterAboutLinks: 3, FooterAccountLinks: 4 };
export const SiteLinkTypes = { General: 1, BecomeEprLink: 2, WarrantyLink: 3, AboutMeButton1: 4, AboutMeButton2: 5, AboutMeButton3: 6, AboutMeButton4: 7 };
export const SiteLinkOpenTargetEnum = { External: 1, SamePage: 2 }
//-------------------------------------------------------
//-------------------------------------------------------

// Loyalty Enums
export const LoyaltyProgramTransactionType = {
  BeginningBalance: 1,
  Correction: 2,
  EndingBalance: 3,
  Sale: 4,
};

// Referral Enums
export const RewardType = {
  DiscountCode: 1,
  Points: 2,
};

export const RewardTrigger = {
  OnRefereePurchase: 1,
  OnRefereeRegister: 2,
};

export const ReferralStatus = {
  Pending: 1,
  Verified: 2,
  Used: 3,
  AlreadyHasAccount: 4,
};

export const AmountType = {
  Percentage: 1,
  FixedAmount: 2,
  FreeShipping: 3,
  BuyXGetY: 4,
};